import React from "react";
import classes from "./AttachmentLoader.scss";
import { ProgressIndicator, IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined, TickCircleFilled } from "@toddle-edu/ds-icons";
import I18nHOC from "UIComponents/I18nHOC";
import {
  timeHelper,
  sizeHelper,
  getTimeLeftInMinutes,
} from "Utils/AttachmentHelpers";

function AttachmentStatus({
  progressValue,
  item,
  name,
  title,
  uploadedSize,
  size,
  t,
}) {
  const startTime = item.startTime;
  const timeLeft = getTimeLeftInMinutes({
    startTime: startTime,
    uploadedSize: uploadedSize,
    totalSize: size,
  });
  const displayUploadSize = sizeHelper({ size: uploadedSize });
  const displayTotalSize = sizeHelper({ size: size });
  const displayTime = timeHelper({ timeInMinutes: timeLeft });

  return (
    <div className={classes.rightContainer}>
      <div className={classes.detailContainer}>
        <div className={classes.fileName} dir="auto">
          {name}
        </div>
        <div className={classes.iconContainer}>
          {progressValue >= 0 && progressValue < 100 && item.cancelToken && (
            <IconButton
              onClick={item.cancelToken}
              icon={<CloseOutlined />}
              variant={"plain"}
              size={"xx-small"}
            />
          )}
          {progressValue >= 100 && (
            <div className={classes.iconContainer}>
              <TickCircleFilled variant="success" size="xxx-small" />
            </div>
          )}
        </div>
      </div>

      <ProgressIndicator variant="progress-bar" progress={progressValue} />

      <div className={classes.labelContainer}>
        {progressValue <= 0 && <div>{t(`common:${title}`)}</div>}
        {progressValue > 0 && progressValue < 100 && (
          <div>{t(displayTime.locale, { count: displayTime.time })}</div>
        )}
        {title === "calculating" && (
          <div className="flex justify-between">
            <div>
              {t("common:uploaded_size_of_total_size", {
                uploadedSize: displayUploadSize,
                size: displayTotalSize,
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

AttachmentStatus.defaultProps = {
  title: "calculating",
};

export default I18nHOC({ resource: ["common", "moment"] })(AttachmentStatus);
